module.exports = __webpack_public_path__ + "5c0ac3712e0fbb468617915b692d23b1.jpg";